import { useContext, useEffect, useState } from "react"
import { FilterContext } from "@/pages/dashboard/components/PageContainer/context";
import { useRequest } from "@/pages/dashboard/utils/customHook";
import { getNightingaleRegionCountriesZone } from "@/pages/dashboard/services/overview";
import { getApiData } from "@/pages/dashboard/services/common";

interface IPropsType {
  accumated: string;
  metricsName: string;
  api: string;
  getParams: Function
  chartLineBarDataFrom: string
}
export const useData = (props: IPropsType) => {
  const { metricsName, accumated, getParams, api, chartLineBarDataFrom } = props;

  const [data, setData] = useState({
    chartData: [],
    tableData: [],
    customChartData:[]
  })

  const contextObj = useContext(FilterContext)
  const { filterVal, filterLoading } = contextObj || {};

  const { sendRequest, isLoading, isError } = useRequest();

  useEffect(() => {
    if (filterLoading) return
    getData(getParams(accumated, metricsName))
  }, [filterVal])

  const getData = async (params: any) => {
    try {
      const res = await sendRequest(getApiData(api, params));
      setData({
        chartData: res?.dwm_data_list || [],
        tableData: res?.dwm_list || [],
        customChartData: chartLineBarDataFrom === 'table' ? (res?.dwm_list || []) : []
      });
    } catch (error) {
      console.log(error)
    }
  }

  return {
    data,
    getData,
    isLoading,
    isError
  }
}